import ReactDOM from 'react-dom'
// Axios
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import { AzureAuth } from './app/components/auth'
import { Provider, useSelector } from 'react-redux';
import store, { SiCuentanosStore } from './app/redux/store';
import { AxiosInterceptor } from './app/interceptors'
import { Spinner } from 'react-bootstrap'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
AxiosInterceptor();
Chart.register(...registerables)

const queryClient = new QueryClient()

const App = () => {
  const loading = useSelector((state: SiCuentanosStore) => state.loading.loading);

  return (
    <div className='App d-flex flex-column flex-root'>
      <AzureAuth />
      {loading && (
        <div className='overlay'>
          <div className='spinner-container'>
            <Spinner animation='grow' variant='primaryCustom'>
              <span className='sr-only'>Cargando...</span>
            </Spinner>
          </div>
        </div>
      )}
    </div>
  );
};

ReactDOM.render(
  
  <QueryClientProvider client={queryClient}>
    <MetronicI18nProvider>
      <Provider store={store}>
        <App /> 
      </Provider>
    </MetronicI18nProvider>
    {/*<ReactQueryDevtools initialIsOpen={false} />*/}
  </QueryClientProvider>,
  document.getElementById('root')
)
